






































import Vue from 'vue'
import Component from 'vue-class-component'

import UserMainInfo from '../../../components/UserMainInfo.vue'
import { errorNotificationWrapper } from '../../../logic/helpers/NotificationService'
import AuthApi from "../Api/Auth.api";
import routerExceptionHandler from '../includes/RouterExceptionHandler'
import { UserGetMe } from '../store/StoreTypes'

@Component({
  components: { UserMainInfo }
})
export default class UserMeta extends Vue {
  get user():UserGetMe | null {
    return this.$store.state.AdminTemplate.user
  }

  get userName(): string {
    if (this.user) {
      return this.user.name
    }

    return ''
  }

  get userAvatar(): string {
    if (this.user) {
      return this.user.avatar
    }

    return ''
  }

  get userLogin(): string {
    if (this.user) {
      return this.user.login
    }

    return ''
  }

  gotoRouteByName(name:string) {
    this.$router.push({ name }).catch(routerExceptionHandler)
  }

  async logout(): Promise<void> {
    this.$store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', true)

    try {
      await AuthApi.logout()

      this.$router.push({ name: 'login' }, () => {
        this.$store.commit('AdminTemplate/UPDATE_USER_INFO', {})

        if (this.$store.state.AdminTemplate.applicationConfig.onLogout) {
          this.$store.state.AdminTemplate.applicationConfig.onLogout()
        }
      })
    } catch (error: unknown) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    } finally {
      this.$store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', false)
    }
  }
}
